<!-- Updates Required toggle -->
<button mat-icon-button (click)="openPanel()" #updatesRequiredOrigin>
    @if (issueOrdersCount > 0) {
        <span
            class="absolute left-0 right-0 top-0 flex h-3 items-center justify-center"
        >
            <span
                class="ml-4 mt-2.5 flex h-4 min-w-4 shrink-0 items-center justify-center rounded-full bg-red-600 px-1 text-xs font-medium text-white"
            >
                {{ issueOrdersCount }}
            </span>
        </span>
    }
    <mat-icon [svgIcon]="'heroicons_outline:exclamation-triangle'"></mat-icon>
</button>

<!-- Updates Required panel -->
<ng-template #updatesRequiredPanel>
    <div
        class="fixed inset-0 flex flex-col overflow-hidden shadow-lg sm:static sm:inset-auto sm:w-90 sm:min-w-90 sm:rounded-2xl"
    >
        <!-- Header -->
        <div
            class="flex shrink-0 items-center bg-red-600 py-4 pl-6 pr-4 text-white"
        >
            <div class="-ml-1 mr-3 sm:hidden">
                <button mat-icon-button (click)="closePanel()">
                    <mat-icon
                        class="text-current icon-size-5"
                        [svgIcon]="'heroicons_solid:x-mark'"
                    ></mat-icon>
                </button>
            </div>
            <div class="text-lg font-medium leading-10">Updates Required</div>
        </div>

        <!-- Content -->
        <div
            class="bg-card relative flex flex-auto flex-col overflow-y-auto sm:max-h-120"
        >
            <!-- Updates list -->
            <div class="divide-y">
                <!-- Order items -->
                @for (order of issueOrders; track order.id) {
                    <div class="group flex hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5">
                        <div class="flex flex-auto cursor-pointer py-4 pl-6">
                            <!-- Dynamic Icon based on issue type - styled to match timeline activities -->
                            <div class="mr-4 flex-shrink-0">
                                <mat-icon
                                    class="icon-size-5"
                                    [svgIcon]="getIssueIcon(order.issueStatus.text)"
                                    [ngClass]="getIssueStatusColorClass(order.issueStatus.text)"
                                >
                                </mat-icon>
                            </div>
                            
                            <!-- Order details -->
                            <div class="flex flex-auto flex-col">
                                <!-- Order ID and name with status dot -->
                                <div class="flex items-center">
                                    <div 
                                        class="w-2 h-2 rounded-full mr-2"
                                        [ngClass]="getStatusClass(order.status)"
                                    ></div>
                                    <div class="font-medium max-w-56 line-clamp-2">{{ order.id }}&nbsp;&nbsp;{{ order.name }}</div>
                                </div>
                                
                                <!-- Issue message -->
                                <div class="text-sm font-medium text-red-600 dark:text-red-400">
                                    {{ order.issueStatus.text }}
                                </div>
                                
                                <!-- Due date with hard/soft designation -->
                                <div class="text-xs text-gray-500 mt-1">
                                    Due {{ order.arrival_date | date: 'MMM dd' }} - 
                                    <span [ngClass]="{'text-amber-500 font-medium': order.hard_due_date}">
                                        {{ order.hard_due_date ? 'Hard' : 'Soft' }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Actions -->
                        <div class="relative my-4 ml-2 mr-6 flex items-center">
                            <button 
                                class="h-8 w-8 opacity-0 group-hover:opacity-100" 
                                mat-icon-button 
                                matTooltip="Edit order"
                                (click)="openOrderForEditing(order)"
                            >
                                <mat-icon 
                                    class="icon-size-5" 
                                    [svgIcon]="'heroicons_outline:pencil-square'"
                                ></mat-icon>
                            </button>
                        </div>
                    </div>
                }

                <!-- No orders requiring updates -->
                @if (!issueOrders || !issueOrders.length) {
                    <div
                        class="flex flex-auto flex-col items-center justify-center px-8 py-12 sm:justify-start"
                    >
                        <mat-icon
                            class="icon-size-6 mb-4 text-green-500"
                            [svgIcon]="'heroicons_outline:check-circle'"
                        ></mat-icon>
                        <div class="mt-5 text-2xl font-semibold tracking-tight">
                            All orders in good standing
                        </div>
                        <div
                            class="text-secondary mt-1 w-full max-w-60 text-center text-md"
                        >
                            There are no orders requiring updates at this time.
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
</ng-template>